import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static environment: HostEnvironment = 'dev';
  static buildId = '';
  static palfinger_api_management = '';
  static palfinger_app_gateway = '';
  static palfinger_app_gateway_v2 = '';
  static help_pages_api = '';
  static palfinger_api_management_subs_key = '';
  static oidc_clientid = '';
  static oidc_scope = '';

  static google_analytics_id = '';
  static application_insights_key = '';

  static domainsForApiManagementSubsKey: string[];

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
    blacklistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
    blacklistedRoutes: [],
  };

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    PRODUCT_REGISTRATION: string;
    CUSTOMER_INVITATION: string;
    HOME: string;
    APP_HELP_PATH: string;
    APP_NEWS_PATH: string;
    APP_HELP_PAGE_PATH: string;
    APP_NEWS_PAGE_PATH: string;
    STATUS_PALDESK_PAGE: string;
    EQUIPMENT_SCREEN_BASEPATH: string;
    PRODUCT_SCREEN_BASEPATH: string;
    EQUIPMENT_GRAPHQL: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    PRODUCT_REGISTRATION: '',
    CUSTOMER_INVITATION: '',
    HOME: '',
    APP_HELP_PATH: '',
    APP_NEWS_PATH: '',
    APP_HELP_PAGE_PATH: '',
    APP_NEWS_PAGE_PATH: '',
    STATUS_PALDESK_PAGE: '',
    EQUIPMENT_SCREEN_BASEPATH: '',
    PRODUCT_SCREEN_BASEPATH: '',
    EQUIPMENT_GRAPHQL: '',
  };

  static FEATUREFLAGS: {
    enable_smart_records: string;
  } = {
    enable_smart_records: '',
  };
}
